import { api } from "./client";

export interface TerritoryStateDto {
  id: string;
  stateCode: string;
  stateName: string;
}

export interface TerritoryLiaisonDto {
  id: string;
  userId: string;
  isPrimary: boolean;
  routingWeight: number;
}

export interface TerritoryDto {
  id: string;
  name: string;
  code: string;
  isActive: boolean;
  states: TerritoryStateDto[];
  liaisons: TerritoryLiaisonDto[];
}

export interface UpsertTerritoryPayload {
  name: string;
  code: string;
  isActive: boolean;
}

export const territoriesApi = {
  list: () => api.get<TerritoryDto[]>("/territories"),
  get: (id: string) => api.get<TerritoryDto>(`/territories/${id}`),
  lookup: (stateCode: string) => api.get<TerritoryDto>(`/territories/lookup/${stateCode}`),
  create: (body: UpsertTerritoryPayload) => api.post<TerritoryDto>("/territories", body),
  update: (id: string, body: UpsertTerritoryPayload) =>
    api.put<TerritoryDto>(`/territories/${id}`, body),
  delete: (id: string) => api.delete<void>(`/territories/${id}`),
  assignStates: (id: string, stateCodes: string[]) =>
    api.put<TerritoryDto>(`/territories/${id}/states`, { stateCodes }),
  assignLiaison: (id: string, userId: string, isPrimary: boolean, routingWeight: number = 1) =>
    api.post<TerritoryDto>(`/territories/${id}/liaisons`, { userId, isPrimary, routingWeight }),
  removeLiaison: (id: string, liaisonId: string) =>
    api.delete<TerritoryDto>(`/territories/${id}/liaisons/${liaisonId}`),
};
